<template>
  <location-list></location-list>
</template>
<script>
import LocationList from "../components/List"

export default {
  name: "location-view-dashboard",
  components: {
    LocationList,
  },
  created() {
    console.log("Dashboard view created");
  },
  data() {
    return {
      locationCount: 0,
    }
  },
}
</script>
